export default {
	yPxToRel(px, sceneProps) {
		return px / sceneProps.sizes.window.h;
	},

	xPxToRel(px, sceneProps, zone = null) {
		if (zone) {
			let translatedX = px - sceneProps.mouse.particleContainersX[zone];
			return translatedX / sceneProps.sizes.container.w;
		}

		return px / sceneProps.sizes.container.w;
	},

	xPxToRelNonZone(px, sceneProps, zone) {
		if (zone) {
			let translatedX = px - sceneProps.mouse.particleContainersX.screens;
			return translatedX / sceneProps.sizes.container.w;
		}

		return px / sceneProps.sizes.container.w;
	},

	xPxToRelLocal(px, sceneProps, zone) {
		//X of container center of container
		//This will centered to zone
		let containerX = sceneProps.mouse.particleContainersX.screens;

		//x point transalted to particle X container position
		//If container is at 1200px width, and at cx 600px and px test is at 1000px then px will +400px

		let translatedX = px - containerX;

		//x of container is centered, but 0-1 goes from full left to right
		//So need to translate the difference to
		//So in case of +400px from 1200px zone at 600px center then it's really at 1000px across the zone
		//So can add half the zone width to the translated X
		//So 400px becomes 1000px
		//And -600px become 0px;
		translatedX += sceneProps.zones[zone].widthPx / 2;

		console.log('_doMicroShapes containerX', containerX);
		console.log('_doMicroShapes translatedX', translatedX);
		console.log('_doMicroShapes sceneProps.zones[zone].widthPx', sceneProps.zones[zone].widthPx);

		return translatedX / sceneProps.zones[zone].widthPx;
	},

	wPxToRel(px, sceneProps, zone = null) {
		if (zone) {
			return px / sceneProps.zones[zone].widthPx;
		}

		return px / sceneProps.sizes.container.w;
	},

	hPxToRel(px, sceneProps, zone) {
		if (zone) {
			return px / sceneProps.mouse.particleContainersX[zone].heightPx;
		}

		return px / sceneProps.sizes.container.h;
	},

	pxToScreenSpace(px, sceneProps, zone) {
		return px;
	},

	screenPxToRelative(screenPoint, sceneProps, zone) {
		//Trying to find abs x + y of target on main timeline without child
		//And translate into rel x/y of position elements that are inside container with 0 as middle and -0.1
		//So need to work out the x of the
		//Say that systems container X is at 500px then items at 600px only need to be at 100px
		//So translated X would be 600px - 500px;
		//Then need to convert the 100px left to value that is relative to content area
		//So if the content area is 800px then 100px is actually -300px and relative say -300px/6000px =

		return {
			x: this.xPxToRel(screenPoint.x, sceneProps, zone),
			y: this.yPxToRel(screenPoint.y, sceneProps)
		};
	}
};
